var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"link",attrs:{"to":_vm.data.url}},[_c('el-menu-item',{key:_vm.data.menuId,attrs:{"index":_vm.data.url}},[_c('menu-title',_vm._b({},'menu-title',_vm.data,false))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }